import { render, staticRenderFns } from "./ListDocuments.vue?vue&type=template&id=dbbabc22&"
import script from "./ListDocuments.vue?vue&type=script&lang=js&"
export * from "./ListDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ListDocuments.vue?vue&type=style&index=0&id=dbbabc22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports